export default "__VITE_ASSET__DYjDNy5W__"